import WMTSTileGrid from "ol/tilegrid/WMTS";

import pickBy from "lodash/pickBy";

function parseLayersStack() {
  let layersStack = localStorage.layersStack === undefined || JSON.parse(localStorage.layersStack).constructor != Object ? {
      hydrants: true,
      pipes: true
    } :
    JSON.parse(localStorage.layersStack);

  return pickBy(layersStack, (v, k) => !(k.startsWith('user') || k.startsWith('temp') || k.startsWith('sketche')));
}

function parseModelWatLegend() {
  if (localStorage.modelWatLegend === undefined) {
    return {
      nodes: {},
      links: {}
    };
  } else {
    return JSON.parse(localStorage.modelWatLegend);
  }
}

let state = {
  apiUrl: process.env.API_URL,
  token: localStorage.accesstoken || '',
  srid: localStorage.srid || '',
  activeModals: [],
  zoom: 0,
  aquagisName: "Zlotoryja",
  username: "",
  bookmarks: [],
  currentBookmark: "",
  errorMessage: "",
  basemapOpacity: localStorage.basemapOpacity === undefined ? 100 : JSON.parse(localStorage.basemapOpacity),
  styles: {},
  showDirectionFlows: false,
  showValvesState: false,
  valvesStateLegend: localStorage.valvesStateLegend === undefined ? true : JSON.parse(localStorage.valvesStateLegend),
  labelsShow: localStorage.labelsshow === undefined ? true : JSON.parse(localStorage.labelsshow),

  //map
  snapTolerance: localStorage.snaptolerance === undefined ? 15 : JSON.parse(localStorage.snaptolerance),
  snapLayers: localStorage.snaplayers === undefined ? {} : JSON.parse(localStorage.snaplayers),
  mapCenter: localStorage.mapposition === undefined ? [283923.09, 366192.07, 15] : JSON.parse(localStorage.mapposition),
  layers: [],
  layersInstance: {},
  //layersSewer: [],
  //layersWater: [],
  appLayers: [],
  userLayers: [],
  userRasterLayers: [],
  tempLayers: [],
  visibleLayers: parseLayersStack(),
  baselayers: [],
  wmsLayers: [],
  currentBasemap: localStorage.basemap || "OpenStreetMap Light",

  appLayersMeta: [],

  sketches: [],
  socket: undefined,

  generateID: 1,

  //dociągnięcie do mapy
  loadToMap: {
    sketche: false,
    user: false,
    wms: false
  },

  map: undefined,
  selectedFeatures: undefined,
  currentEditedLayer: undefined,
  currentCoordSystem: '2000 (V)',

  editionOn: false,
  tableDataActive: false,

  // dicts
  dicts: [],
  currentEditedDict: undefined,
  dictForLayer: undefined,
  newFieldLayer: undefined,
  newFieldDict: undefined,

  // inspections
  inspectionTasks: [],
  inspectionTask: undefined,
  inspectionCards: [],
  hydrantInspectionCard: undefined,

  // hydrants
  hydrants: [],
  selectedHydrants: [],
  selectedHydrantsEdited: [],
  hydrantData: undefined,

  // terminals
  terminals: [],
  terminalData: undefined,

  // schedules
  schedules: [],

  // tasks
  tasks: [],
  task: {},
  currentTask: undefined,
  taskMaterials: [],

  // folders
  folders: [],
  folderData: undefined,
  currentFolderArea: undefined,

  // attachments
  attachments: [],
  objectAttachments: [],

  currentEditedObject: undefined,

  //	events
  featureEvents: undefined,

  // servitude
  servitudes: undefined,
  servitudeData: {},
  analysisResult: {},
  isTransmissionEasementAdding: false,

  // variances
  variancesList: [],
  variancesStatus: undefined,
  variancesType: undefined,
  currentVariance: undefined,
  currentAddingVariance: false,
  currentVarianceArea: 0,

  // settings
  users: [],
  usersMap: {},
  user: {},
  events: [],
  eventUser: undefined,
  settings: {},
  currentUserId: undefined,
  currentUserGroup: undefined,
  currentUsername: undefined,

  //scada
  scadaPoints: [],
  scadaFeaturesArr: [],
  currentScadaPoint: undefined,
  scadaAlarmsLink: "https://zlotoryja.aquard.pl/telwinweb/Default.aspx?UserName=ZLOTORYJAGIS&Password=82hk9qrm&Sheet=",
  scadaDmaLink: "",
  scadaInterval: localStorage.scadaInterval === undefined ? 5 : localStorage.scadaInterval,
  lastScadaUpdate: undefined,
  hydranetUrl: "https://bochnia.hydranet.pl/hydranet/expert/#/wmr/meter/",

  // WMTS
  wmtsTilegrid: new WMTSTileGrid({
    origin: [144693.2803470374, 908411.1932280732],
    matrixIds: [
      "EPSG:2180:0",
      "EPSG:2180:1",
      "EPSG:2180:2",
      "EPSG:2180:3",
      "EPSG:2180:4",
      "EPSG:2180:5",
      "EPSG:2180:6",
      "EPSG:2180:7",
      "EPSG:2180:8",
      "EPSG:2180:9",
      "EPSG:2180:10",
      "EPSG:2180:11",
      "EPSG:2180:12",
      "EPSG:2180:13",
      "EPSG:2180:14",
      "EPSG:2180:15",
      "EPSG:2180:16",
      "EPSG:2180:17",
      "EPSG:2180:18"
    ],
    resolutions: [
      1528.4651860344106,
      764.2325930172053,
      382.11629650860266,
      191.05814825430133,
      95.52907412715066,
      47.76453706357533,
      23.882268531787666,
      11.941134265893833,
      5.9705671329469165,
      2.9852835664734583,
      1.4926417832367291,
      0.7463208916183646,
      0.3731604458091823,
      0.1865802229045911,
      0.0932901114522956,
      0.0466450557261478,
      0.0233225278630739,
      0.0116612639315369,
      0.0058306319657685
    ],
    tileSize: 512
  }),
  wmtsTilegridGeoportal: new WMTSTileGrid({
    origin: [100000, 850000],
    matrixIds: [
      "EPSG:2180:0",
      "EPSG:2180:1",
      "EPSG:2180:2",
      "EPSG:2180:3",
      "EPSG:2180:4",
      "EPSG:2180:5",
      "EPSG:2180:6",
      "EPSG:2180:7",
      "EPSG:2180:8",
      "EPSG:2180:9",
      "EPSG:2180:10",
      "EPSG:2180:11",
      "EPSG:2180:12",
      "EPSG:2180:13",
      "EPSG:2180:14",
      "EPSG:2180:15",
      "EPSG:2180:16"
    ],
    resolutions: [
      8466.6836,
      4233.3418,
      2116.6709,
      1058.33545,
      529.167725,
      264.5838625,
      132.29193125,
      66.145965625,
      26.458386249999997,
      13.229193124999998,
      6.614596562499999,
      2.645838625,
      1.3229193125,
      0.529167725,
      0.2645838625,
      0.13229193125,
      0.06614596562
    ],
    tileSize: 512
  }),
  // FAILURES
  failures: {},
  currentFailure: undefined,
  // Refurubishments / repairs
  refurbishments: [],
  currentRefurbishment: undefined,
  // Costs
  failureCosts: [],
  refurbishmentCosts: [],
  taskCosts: [],
  // Video
  videoInspectionCards: [],
  videoInspectionCard: {},
  currentVideo: undefined,
  //Modelowanie wodociągowe modelWat
  includeReceiver: localStorage.includeReceiver === undefined ? true : localStorage.scadaInterval,
  modelWatDisplaySettings: {
    nodes: {
      size: 5,
      display: true,
      sizeProportions: false,
      attribute: "null",
      /*displayContour: false*/
    },
    links: {
      width: 3,
      display: true,
      sizeProportions: false,
      attribute: "null",
    },
    labels: {
      displayNodesID: false,
      displayNodesValues: false,
      displayLinksID: false,
      displayLinksValues: false
    },
    legend: parseModelWatLegend(),
    /*symbols: {
        displayReservoirs: true,
        displayPumps: true,
        displayValves: true,
        displayOutflow: false,
        displaySource: false,
        displayProjectedReceivers: true
      },
      arrow: {
        displayArrow: false,
        size: ""
      }*/
  },
  modelWatTimeStep: 1,

  virtualRecipients: [],
  virtualRecipient: {},

  //Hydranet
  hydraNetWatermeters: [],
  watermeters: []
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js